import { render, staticRenderFns } from "./DictTypeList.vue?vue&type=template&id=e3dcb2b6&scoped=true&"
import script from "./DictTypeList.vue?vue&type=script&lang=js&"
export * from "./DictTypeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3dcb2b6",
  null
  
)

export default component.exports